import { render } from "./simpleForm.vue?vue&type=template&id=f2df7dd4&scoped=true"
import script from "./simpleForm.vue?vue&type=script&lang=js"
export * from "./simpleForm.vue?vue&type=script&lang=js"

import "./simpleForm.vue?vue&type=style&index=0&id=f2df7dd4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2df7dd4"]])

export default __exports__